var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-button',{on:{"click":function($event){return _vm.getLocate()}}},[_vm._v("Exibe localização")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }